import { Factory } from '../../services/Factory';

namespace app.controllers.exporting {

  interface IExportScope extends angular.IScope {
    project: any;
    collections: any[];
    exportInstance: any;
    loadFileFormats: any[];
    exports: any[];
    exportTemplate: any;
    sortableOptions: any;
    initializing: boolean;
    saving: boolean;
    uploading: boolean;
    currentStep: number;
    maxSteps: number;
    toggle: { all: boolean };
    editFormat: any;
    relativitySettings: any;
    relativitySettingsList: Array<{ name: string; workspace: { name: string, id: string }, fields: Array<any> }>;
    relativityWorkspaces: { list: Array<{ id: string, name: string }> };
    close: Function;
    getSuggestions: Function;
    save: Function;
    next: Function;
    back: Function;
    selectAllCollections: Function;
    deselectAllCollections: Function;
    editLoadFileFormat: Function;
    editRelativitySettings: Function;
    addCustomField: Function;
    addTagField: Function;
    cancelEditLoadFileFormat: Function;
    saveLoadFileFormat: Function;
    saveRelativitySettings: Function;
    native: { enabled: boolean };
    nativeOutputType: { type: OutputType };
    _: any;
    OutputType: any;
    ColorSetting: any;
    LoadFileFieldType: any;
    warningSelectionsAccepted: boolean;
    onPlaceholderTagSelect: Function;
    endorsementType: { east: any, west: any, south: any };
  }

  export enum LoadFileFieldType {
    Normal = "normal",
    Custom = "custom",
    Tag = "tag"
  }

  export class ExportController {
    constructor(private scope: IExportScope, modal: any, timeout: any, project: any, exportService: app.services.exporting.ExportService, notificationService: app.services.INotificationService, tagService: app.services.tagging.TagService, private loadFileFormatService: app.services.exporting.LoadFileFormatService, private relativityWorkspaceService: app.services.exporting.RelativityWorkspaceService, private relativitySettingsService: app.services.exporting.RelativitySettingsService, accountService: app.services.account.AccountService, $sce: angular.ISCEService) {
      const OutputType = app.model.exporting.OutputType;
      const EndorsementType = app.model.exporting.EndorsementType;
      const TiffExportColorFileFormat = app.model.exporting.TiffExportColorFileFormat;
      const Endorsement = app.model.exporting.Endorsement;

      const handleTemplateChanged = (id: any) => {
        let format = angular.copy(_.findWhere(scope.loadFileFormats, {"id": id}));
        format.template = id;
        angular.extend(scope.editFormat, _.omit(format, ["id", "name"]));
      };

      const handleExportTemplateChanged = (id: any) => {
        if (!id) {
          return;
        }

        let exportTemplate = angular.copy(_.findWhere(scope.exports, {"id": id}));

        // Keep track of these for later on
        let hasNative = _.contains(exportTemplate.outputTypes, app.model.exporting.OutputType.Native);
        let hasNativeWithPlaceholder = _.contains(exportTemplate.outputTypes, app.model.exporting.OutputType.NativeWithPlaceholder);

        const southWestEndorsement = exportTemplate.southWestEndorsement;
        const southEndorsement = exportTemplate.southEndorsement;
        const southEastEndorsement = exportTemplate.southEastEndorsement;

        scope.endorsementType.west = southWestEndorsement[0]?.type || app.model.exporting.EndorsementType.None;
        scope.endorsementType.south = southEndorsement[0]?.type || app.model.exporting.EndorsementType.None;
        scope.endorsementType.east = southEastEndorsement[0]?.type || app.model.exporting.EndorsementType.None;

        exportTemplate.southWestEndorsement = southWestEndorsement.map(e => ({id: e.id, name: e.value}));
        exportTemplate.southEndorsement = southEndorsement.map(e => ({id: e.id, name: e.value}));
        exportTemplate.southEastEndorsement = southEastEndorsement.map(e => ({id: e.id, name: e.value}));

        exportTemplate.colorTagId = exportTemplate.colorTag; // Little Naming error from backend.

        scope.tiffExportColorFileFormat.value = exportTemplate.tiffExportColorFileFormat === "JPG";

        timeout(() => angular.extend(scope.exportInstance, _.omit(exportTemplate, ["id", "name", "account", "createdAt", "createdAtString", "directDownloadPath", "exportTag", "job", "path", "paths", "projectId", "status", "includeContainerExportTag", "containerExportTag"])));

        // Now set whether they checked the native button
        scope.native = {enabled: hasNative || hasNativeWithPlaceholder};

        timeout(() => {
          // Set nativeOutputType after native to keep the watches in line
          if (hasNative) {
            scope.nativeOutputType.type = app.model.exporting.OutputType.Native;
          } else if (hasNativeWithPlaceholder) {
            scope.nativeOutputType.type = app.model.exporting.OutputType.NativeWithPlaceholder;
          }
        }, 500);
      };

      const getStatistics = () => {
        if (scope.exportInstance.collectionIds.length > 0) {
          const tags = {
            and: _.pluck(scope.exportInstance.tags.and, "id"),
            or: _.pluck(scope.exportInstance.tags.or, "id"),
            not: _.pluck(scope.exportInstance.tags.not, "id")
          };
          const newExport = new app.model.exporting.Export(scope.exportInstance.projectId, {
            collectionIds: scope.exportInstance.collectionIds,
            tags,
            containerExportTag: scope.exportInstance.includeContainerExportTag ? scope.exportInstance.containerExportTag instanceof Object ? scope.exportInstance.containerExportTag : null : null,
            includeContainerExportTag: scope.exportInstance.includeContainerExportTag,
            includeRedactedResources: scope.exportInstance.includeRedactedResources,
            includeResourcesWithZeroPages: scope.exportInstance.includeResourcesWithZeroPages,
            includeResourcesWithProcessingExceptions: scope.exportInstance.includeResourcesWithProcessingExceptions,
            includeDuplicateResources: scope.exportInstance.includeDuplicateResources
          });
          exportService.GetExportStatistics(newExport).then(stats => {
            scope.stats = stats.data;
          });
        } else {
          scope.stats = {
            resourceCount: 0,
            pageCount: 0,
            size: 0,
            duplicates: 0,
            exceptions: 0,
            zeroPages: 0,
            redacted: 0
          };
        }
      };

      this.Initialize(scope, project);

      scope._ = _;
      scope.OutputType = app.model.exporting.OutputType;
      scope.ColorSetting = app.model.exporting.ColorSetting;
      scope.LoadFileFieldType = LoadFileFieldType;
      scope.project = project;
      scope.native = {enabled: false};
      scope.nativeOutputType = {type: app.model.exporting.OutputType.Native};
      scope.initializing = true;
      scope.saving = false;
      scope.uploading = false;
      scope.currentStep = 1;
      scope.maxSteps = 4;
      scope.toggle = {all: true};
      scope.tiffExportColorFileFormat = {value: false};
      scope.sortableOptions = {
        handle: ".iio-drag-handle",
        axis: "y"
      };
      scope.EndorsementType = app.model.exporting.EndorsementType;
      scope.endorsementType = { east: app.model.exporting.EndorsementType.Bates, west: app.model.exporting.EndorsementType.None, south: app.model.exporting.EndorsementType.None };
      scope.exportInstance = new app.model.exporting.Export(project.id, {});
      scope.exportInstance.southEastEndorsement = [{id: "Bates", name: "Bates"}];
      scope.exportTemplate = {
        id: null
      };
      scope.close = () => !scope.saving && modal.close();
      scope.onPlaceholderTagSelect = item => scope.exportInstance.tagPlaceholder = item;
      scope.getSuggestions = (value: any) => tagService.GetSuggestions(project.id, value, 7).then((response: any) => response.data);
      scope.selectAllCollections = () => scope.exportInstance.collectionIds.length > 0 && scope.exportInstance.collectionIds.splice(0) || scope.collections.forEach(c => scope.exportInstance.collectionIds.push(c.id));
      scope.deselectAllCollections = () => scope.exportInstance.collectionIds.splice(0);

      // Temporary workaround for testing direct to rel, only show to Austin
      // TODO: When removing this check, it should go back to all internal users
      const email = accountService.GetEmail().toLowerCase();
      const exportToRelativityFlagEnabled = !!(window as any).__features?.exportToRelativity;
      scope.directToRelativityEnabled = !!project.organizationId && (
        exportToRelativityFlagEnabled
          ? email.endsWith('@innovativedriven.com')
          : email === 'austin.smith-bartlett@innovativedriven.com'
      );
      scope.relativitySettings = new app.model.exporting.RelativitySettings("", undefined, "", [], false, undefined, undefined, undefined, [], []);
      scope.relativitySettingsList = [];
      scope.relativityWorkspaces = {list: []};
      scope.selectModes = [];
      scope.overlayIdentifiers = [];
      scope.multiSelectOptions = [];
      scope.tokens = [];
      scope.relativityFields = [];
      scope.relativityFolders = [];
      scope.importModeTooltipContent = $sce.getTrustedHtml(`
        <ul>
          <li>Append Only— Will load documents as new records.</li>
          <li>Overlay Only— Updates existing records only.</li>
          <li>Append/Overlay—Will load new records and overlay data onto existing records.</li>
        </ul>`
      );
      scope.overlayIdentifierTooltipContent =  $sce.getTrustedHtml("This field acts as a link indicating where to overlay the data.");
      scope.multiSelectTooltipContent = $sce.getTrustedHtml(`
        <ul>
          <li>Use Relativity Defaults— Values are merged or replaced according to overlay behavior settings in the environment.</li>
          <li>Merge Values—Values are merged regardless of the overlay behavior settings in the environment.</li>
          <li>Replace Values—Replaces all values regardless of the overlay settings in the environment.</li>
        </ul>
      `)


      scope.save = (exportInstance: Export) => {
        scope.saving = true;
        console.log('saving export');

        let exportResource = exportService.Create(new app.model.exporting.Export(exportInstance.projectId, {
          name: exportInstance.name,
          prefix: exportInstance.prefix,
          delimiter: exportInstance.delimiter,
          startValue: exportInstance.startValue,
          zeroPaddingLength: exportInstance.zeroPaddingLength,
          filesPerDirectory: exportInstance.filesPerDirectory,
          collectionIds: exportInstance.collectionIds,
          tags: {
            and: _.pluck(exportInstance.tags.and, "id"),
            not: _.pluck(exportInstance.tags.not, "id"),
            or: _.pluck(exportInstance.tags.or, "id")
          },
          loadFileFormatIds: exportInstance.directToRelativity ? [exportInstance.relativitySettingsId] : exportInstance.loadFileFormatIds,
          relativitySettingsId: exportInstance.relativitySettingsId,
          colorSetting: exportInstance.colorSetting,
          tiffExportColorFileFormat: exportInstance.tiffExportColorFileFormat,
          colorTagId: exportInstance.colorTagId === "" ? null : exportInstance.colorTagId,
          outputCustomNativeFilename: exportInstance.outputCustomNativeFilename,
          outputOriginalNativePaths: exportInstance.outputOriginalNativePaths,
          spreadsheetPlaceholder: exportInstance.spreadsheetPlaceholder,
          presentationPlaceholder: exportInstance.presentationPlaceholder,
          southWestEndorsement: exportInstance.southWestEndorsement instanceof Array ? exportInstance.southWestEndorsement.map((e: {
            id: string,
            name: string
          }) => new Endorsement(e.id, e.name, scope.endorsementType.west)) : undefined,
          southEndorsement: exportInstance.southEndorsement instanceof Array ? exportInstance.southEndorsement.map((e: {
            id: string,
            name: string
          }) => new Endorsement(e.id, e.name, scope.endorsementType.south)) : undefined,
          southEastEndorsement: exportInstance.southEastEndorsement instanceof Array ? exportInstance.southEastEndorsement.map((e: {
            id: string,
            name: string
          }) => new Endorsement(e.id, e.name, scope.endorsementType.east)) : undefined,
          tagPlaceholderEnabled: exportInstance.tagPlaceholderEnabled,
          tagPlaceholder: exportInstance.tagPlaceholder,
          containerExportTag: exportInstance.containerExportTag,
          includeContainerExportTag: exportInstance.includeContainerExportTag,
          outputTypes: exportInstance.directToRelativity ? [OutputType.Text, OutputType.Native] : exportInstance.outputTypes,
          virusPlaceholderText: exportInstance.virusPlaceholderText,
          failedToImagePlaceholderText: exportInstance.failedToImagePlaceholderText,
          nativeFormatPlaceholderText: exportInstance.nativeFormatPlaceholderText,
          includeDuplicateResources: exportInstance.includeDuplicateResources,
          includeRedactedResources: exportInstance.includeRedactedResources,
          includeResourcesWithProcessingExceptions: exportInstance.includeResourcesWithProcessingExceptions,
          includeResourcesWithZeroPages: exportInstance.includeResourcesWithZeroPages,
          keepPageOrientation: exportInstance.keepPageOrientation,
          directToRelativity: exportInstance.directToRelativity
        }));

        exportService.Save(exportResource).then(() => {
          scope.saving = false;
          scope.close();

          notificationService.addSuccess({
            title: "Export in progress",
            description: "You will be notified when the export is complete.",
            timeout: 5000
          });
        }).catch(e => {
          if (e.data.errors[0].defaultMessage === "Export name already exists") {
            scope.saving = false;
          }
        });
      };
      scope.back = () => {
        console.log("back");
        scope.currentStep--;
      };
      scope.next = () => {
        if (scope.currentStep === scope.maxSteps) {
          scope.save(scope.exportInstance);
        } else {
          scope.currentStep++;
        }
      };
      scope.editLoadFileFormat = (format: any) => {
        scope.currentStep = 2.1;

        if (format) {
          scope.editFormat = angular.copy(format);
        } else {
          // New Load File Format
          scope.editFormat = {};

          // Use the CSV template as the default setup
          handleTemplateChanged(_.findWhere(scope.loadFileFormats, {"name": "IIO CSV"}).id);
        }
      };
      scope.editRelativitySettings = (settings: any) => {
        scope.currentStep = 2.1;

        if (settings) {
          let savedSettings = angular.copy(settings);

          savedSettings.fields.forEach(field => field.outputName && ((field.outputName as any) = [{
            name: field.outputName,
            type: "string"
          }]));

          timeout(() => {
            scope.relativitySettings = savedSettings
            scope.editMode = true;
            scope.relativityWorkspaces.list = [savedSettings.workspace];
          });
        } else {
          // New Load File Format
          scope.relativitySettings = new app.model.exporting.RelativitySettings("", undefined, "", [], false, undefined, undefined, undefined, [], []);
        }
      };
      scope.addCustomField = () => {
        scope.editFormat.fields.splice(0, 0, {
          type: LoadFileFieldType.Custom,
          name: "",
          outputName: "",
          isEnabled: true
        });
      };
      scope.addTagField = () => {
        scope.editFormat.fields.splice(0, 0, {
          type: LoadFileFieldType.Tag,
          name: "",
          outputName: "",
          isEnabled: true
        });
      };
      scope.cancelEditLoadFileFormat = () => {
        scope.currentStep = 2;
        scope.relativitySettings = new app.model.exporting.RelativitySettings("", undefined, "", [], false, undefined, undefined, undefined, [], []);
        scope.relativityWorkspaces = {list: []};
        scope.selectModes = [];
        scope.overlayIdentifier = [];
        scope.multiSelect = [];
        scope.tokens = [];
        scope.relativityFields = [];
      }
      scope.saveLoadFileFormat = async (format: ILoadFileFormat) => {
        format.projectId = project.id;
        console.log(format);
        scope.saving = true;

        try {
          if (format.id) {
            // Have an ID, so just update
            await loadFileFormatService.Update(format);
          } else {
            // Create a new one
            await loadFileFormatService.Save(format);
          }

          scope.loadFileFormats = await loadFileFormatService.FindAll({projectId: project.id});
          scope.saving = false;
          scope.cancelEditLoadFileFormat();
          scope.$applyAsync();

          notificationService.addSuccess({
            title: `Load File Format ${format.id ? "updated" : "added"} successfully`,
            timeout: 2500
          });
        } catch {
          scope.saving = false;
          console.log("Error!");
        }
      };
      scope.saveRelativitySettings = async (settings: any) => {
        try {
          settings.projectId = project.id;
          settings.fields.forEach(field => field.outputName && (field.outputName = field.outputName ? (field.outputName[0] as any).name : ""));

          if (settings.id) {
            // Have an ID, so just update
            await relativitySettingsService.Update(settings);
          } else {
            // Create a new one
            await relativitySettingsService.Save(settings);
          }

          scope.relativitySettingsList = await relativitySettingsService.FindAll({projectId: project.id});
          scope.relativitySettings = new app.model.exporting.RelativitySettings("", undefined, "", [], false, undefined, undefined, undefined, [], []);
          scope.saving = false;
          scope.cancelEditLoadFileFormat();
          scope.$applyAsync();

          notificationService.addSuccess({
            title: `Load File Format ${settings.id ? "updated" : "added"} successfully`,
            timeout: 2500
          });
        } catch (e) {
          scope.saving = false;
          console.log("Error!");
        }
      };

      scope.$watch("editFormat.template", id => id && handleTemplateChanged(id));

      scope.$watch("exportTemplate.id", id => id && handleExportTemplateChanged(id));

      scope.$watch("toggle.all", value => {
        if (scope.editFormat) {
          scope.editFormat.fields.forEach((field: any) => field.isEnabled = value);
        }

        scope.relativitySettings.fields.forEach((field: any) => field.isEnabled = value);
      }, true);

      scope.$watchCollection("exportInstance.outputTypes", (value: OutputType[]) => {
        if (_.contains(value, OutputType.NativeWithPlaceholder) && !_.contains(value, OutputType.Pdf) && !_.contains(value, OutputType.Tiff) && !_.contains(value, OutputType.NativePdf)) {
          scope.nativeOutputType.type = OutputType.Native;
        }
      });

      scope.$watch("nativeOutputType.type", (current: OutputType, previous: OutputType) => {
        scope.exportInstance.outputTypes = _.without(scope.exportInstance.outputTypes, previous);
        scope.exportInstance.outputTypes.push(current);
      });

      scope.$watch("native.enabled", (value: boolean) => {
        if (!value) {
          scope.exportInstance.outputTypes = _.without(scope.exportInstance.outputTypes, OutputType.Native, OutputType.NativeWithPlaceholder);
        } else {
          scope.exportInstance.outputTypes.push(OutputType.Native);
        }
      });

      scope.$watch("endorsementType.west", v => {
        switch (v) {
          case EndorsementType.Bates:
            scope.exportInstance.southWestEndorsement = [{id: "Bates", name: "Bates", type: EndorsementType.Bates}];
            break;
          case EndorsementType.None:
            scope.exportInstance.southWestEndorsement = [];
            break;
          case EndorsementType.Text:
            scope.exportInstance.southWestEndorsement = [];
            break;
          case EndorsementType.Tag:
            scope.exportInstance.southWestEndorsement = [];
            break;
          default:
            break;
        }
      });

      scope.$watch("endorsementType.south", v => {
        switch (v) {
          case EndorsementType.Bates:
            scope.exportInstance.southEndorsement = [{id: "Bates", name: "Bates", type: EndorsementType.Bates}];
            break;
          case EndorsementType.None:
            scope.exportInstance.southEndorsement = [];
            break;
          case EndorsementType.Text:
            scope.exportInstance.southEndorsement = [];
            break;
          case EndorsementType.Tag:
            scope.exportInstance.southEndorsement = [];
            break;
          default:
            break;
        }
      });

      scope.$watch("endorsementType.east", v => {
        switch (v) {
          case EndorsementType.Bates:
            scope.exportInstance.southEastEndorsement = [{id: "Bates", name: "Bates", type: EndorsementType.Bates}];
            break;
          case EndorsementType.None:
            scope.exportInstance.southEastEndorsement = [];
            break;
          case EndorsementType.Text:
            scope.exportInstance.southEastEndorsement = [];
            break;
          case EndorsementType.Tag:
            scope.exportInstance.southEastEndorsement = [];
            break;
          default:
            break;
        }
      });

      scope.$watch("tiffExportColorFileFormat", (v: {
        value: boolean
      }) => scope.exportInstance.tiffExportColorFileFormat = v?.value ? TiffExportColorFileFormat.JPG : TiffExportColorFileFormat.TIF, true);

      scope.$watch("directToRelativityEnabled", v => {
        if(v === true) {
          this.relativitySettingsService.FindAll({projectId: project.id}).then(result => {
            scope.relativitySettingsList = result;
          });
        }
      });

      scope.$watchGroup(["exportInstance.tags.and", "exportInstance.tags.or", "exportInstance.tags.not", "exportInstance.includeContainerExportTag", "exportInstance.containerExportTag", "exportInstance.includeRedactedResources", "exportInstance.includeResourcesWithProcessingExceptions", "exportInstance.includeResourcesWithZeroPages", "exportInstance.includeDuplicateResources"], getStatistics);

      scope.$watchCollection("exportInstance.collectionIds", () => {
        getStatistics();
        scope.exportInstance.collectionNames = _.pluck(_.select(scope.collections, c => _.include(scope.exportInstance.collectionIds, c.id)), "name");
      });

      scope.$watchCollection("exportInstance.loadFileFormatIds", () => {
        scope.exportInstance.loadFileFormatNames = _.pluck(_.select(scope.loadFileFormats, c => _.include(scope.exportInstance.loadFileFormatIds, c.id)), "name");
      });

      scope.$watchCollection("relativityWorkspaces.list", (wl: Array<{ id: string, name: string }>) => {
        if (scope.editMode) {
          scope.editMode = false;
          this.relativityWorkspaceService.GetFields(scope.project.id, scope.relativitySettings.workspace.id).success(relativityFields => {
            scope.relativityFields = relativityFields;
          });

          this.InitializeDropDownOptions();
        } else {
          if (wl.length > 0 && wl[0].id.length > 0) {
            this.relativitySettingsService.GetFields(scope.project.id).success(iioFields => {
              _.each(iioFields, f => {
                f.outputName = null;
                f.isEnabled = false;
              });

              scope.relativitySettings.fields = iioFields;
              scope.relativitySettings.workspace = wl[0];

              this.relativityWorkspaceService.GetFields(scope.project.id, scope.relativitySettings.workspace.id).success(relativityFields => {
                let mappedField = _.find(relativityFields, rf => rf.isIdentifier);

                if (mappedField) {
                  iioFields[0].outputName = [mappedField];
                  iioFields[0].isEnabled = true;
                }

                iioFields.slice(1).forEach(field => {
                  mappedField = _.find(relativityFields, rf => app.model.exporting.RelativityFieldMappings[field.name] == rf.name);

                  if (mappedField) {
                    field.outputName = [mappedField];
                    field.isEnabled = true;
                  }
                });

                scope.relativityFields = relativityFields;
                this.InitializeDropDownOptions();
              });
            });
          } else {
            scope.relativitySettings.fields = [];
            this.ResetDropDownOptions();
          }
        }
      });
    }

    private InitializeDropDownOptions() {
      this.scope.selectModes = [{id: "1", name: "Append Only"}, {id: "2", name: "Overlay Only"}, {id: "3", name: "Append/Overlay"}];
      this.scope.overlayIdentifiers = [{id: "Identifier", name: "Identifier"}, {
        id: "BegBates",
        name: "Beg Bates"
      }, {id: "RelativePath", name: "Relative Path"}];
      this.scope.multiSelectOptions = [{id: "1", name: "Use Relativity Defaults"}, {
        id: "2",
        name: "Merge All"
      }, {id: "3", name: "Replace All"}];
      this.scope.tokens = [{id: "RITM", name: "Identifier 1"}, {id: "Evidence", name: "Identifier 2"}, {
        id: "Release",
        name: "Identifier 3"
      }, {id: "Folders", name: "Folders"}, {
        id: "Custodian",
        name: "Custodian"
      }, {id: "CollectionId", name: "Collection ID"}];

      this.relativityWorkspaceService.GetFolders(this.scope.project.id, this.scope.relativitySettings.workspace.id).success(response => {
        this.scope.relativityFolders = response;
      });
    }

    private ResetDropDownOptions() {
      this.scope.selectModes = [];
      this.scope.overlayIdentifiers = [];
      this.scope.multiSelectOptions = [];
      this.scope.tokens = [];
      this.scope.relativityFolders = [];
    }

    private async Initialize(scope, project) {
      scope.loadFileFormats = await this.loadFileFormatService.FindAll({projectId: project.id});
    }
  }

  frontendApp.controller("ExportController", ["$scope", "$uibModalInstance", "$timeout", "project", "ExportService", "NotificationService", "TagService", "LoadFileFormatService", "RelativityWorkspaceService", "RelativitySettingsService", "AccountService", "$sce", Factory.Create(ExportController)]);
}
